let initialized = false;

const getId = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

const injectScript = (src: string, attrs: Record<string, unknown> = {}) => {
    if (!src) return;
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    Object.entries(attrs).forEach(([key, val]) => {
        script.setAttribute(key, String(val));
    });
    document.head.appendChild(script);
};

const injectInlineScript = (id: string, content: string) => {
    if (document.getElementById(id)) return;
    const script = document.createElement('script');
    script.id = id;
    script.text = content;
    document.head.appendChild(script);
};

const hasConsent = () => {
    try {
        return window.localStorage.getItem('cookie_consent_v1') === 'accepted';
    } catch {
        return false;
    }
};

export const initAnalytics = () => {
    if (initialized || typeof window === 'undefined') return;
    if (!hasConsent()) return;
    initialized = true;

    const gaId = getId(import.meta.env.VITE_GA_ID);
    const gtmId = getId(import.meta.env.VITE_GTM_ID);
    const metaPixelId = getId(import.meta.env.VITE_META_PIXEL_ID);

    if (gaId) {
        injectScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`);
        injectInlineScript(
            'ga-inline-init',
            `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config',${JSON.stringify(gaId)});`
        );
    }

    if (gtmId) {
        injectInlineScript(
            'gtm-inline-init',
            `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',${JSON.stringify(gtmId)});`
        );
    }

    if (metaPixelId) {
        injectInlineScript(
            'meta-pixel-inline-init',
            `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init',${JSON.stringify(metaPixelId)});fbq('track','PageView');`
        );
    }
};

export const trackPageView = (path?: string) => {
    if (typeof window === 'undefined' || !hasConsent()) return;
    const pagePath = path || `${window.location.pathname}${window.location.search}`;
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', { page_path: pagePath });
    }
    if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView');
    }
};

export const trackEvent = (eventName: string, params: Record<string, unknown> = {}) => {
    if (typeof window === 'undefined' || !hasConsent()) return;
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
    }
    if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...params });
    }
    if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, params);
    }
    if (typeof window.umami?.track === 'function') {
        window.umami.track(eventName, params);
    }
};
